module.exports = __webpack_public_path__ + "static/apple-91580edf14ef33a08098797f442a0904.png";